export type ForbiddenErrorVariant = 'neutral' | 'warning' | 'positive' | 'negative'

export type ForbiddenErrorActionKind = 'close' | 'help'

export interface ForbiddenErrorAction {
  kind: ForbiddenErrorActionKind
  label: string
  variant: 'primary-solid' | 'neutral-subtle'
}

export interface ForbiddenErrorStateInfo {
  type: string
  title: string
  description: string
  icon: string
  variant: ForbiddenErrorVariant
  primaryAction: ForbiddenErrorAction
  secondaryAction: ForbiddenErrorAction
}

const CLOSE_ACTION: ForbiddenErrorAction = { kind: 'close', label: 'Fechar', variant: 'primary-solid' }
const HELP_ACTION: ForbiddenErrorAction = { kind: 'help', label: 'Falar com a Stone', variant: 'neutral-subtle' }

export const GLOBAL_FORBIDDEN_ERROR_STATES: Record<string, ForbiddenErrorStateInfo> = {
  'srn:error:child_resource_forbidden': {
    type: 'srn:error:child_resource_forbidden',
    title: 'Esta funcionalidade está inativa',
    description: 'Para entender o motivo, entre em contato com a Stone.',
    icon: 'circle-alert',
    variant: 'neutral',
    primaryAction: CLOSE_ACTION,
    secondaryAction: HELP_ACTION
  }
}

export function resolveForbiddenErrorState(type?: string | null): ForbiddenErrorStateInfo | null {
  if (!type) return null

  const key = Object.keys(GLOBAL_FORBIDDEN_ERROR_STATES).find(entry => entry.toLowerCase() === type.toLowerCase())

  return key ? GLOBAL_FORBIDDEN_ERROR_STATES[key] : null
}
